import { canApproveForm } from '../onboarding-action-policy.service';
import templateUrl from './va-w4.component.html';
import moment from 'moment';
import { PreviewSignatureModal } from '../preview-signature-modal/preview-signature-modal.component';
import { InfoModal } from '../info-modal/info-modal.component';
import { OwnerPreviewSignatureModal } from '../preview-signature-modal/owner-preview-signature-modal.component';

// Virginia VA-4 (StateProvinceID 48, requestTypeId 2). APEX-867.
// Employee-only certificate (no employer section). Step 3/4 checkboxes use PDF on-value "On".
// Numeric exemption fields autofill "0" when left blank.
const VA_STATE_ID = 48;

export const VaW4Component = {
    templateUrl,
    controller: VaW4Controller,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        ownerView: "<",
        owner: "<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        userInputs: "<",
        savedInputs: "<",
        maritalStatus: "<",
        addlInputs: "<",
        ownerInfo: "<",
        stateTaxInfo: "<",
        showSignaturePopup: "<",
        close: "&",
        dismiss: "&"
    }
};

function VaW4Controller(onboardingActionPolicy, onboardingDocumentService, $state, $scope, $uibModal, $q, utilityService, localeService, onboardingDocumentViewService, employeeService) {
    'ngInject';
    const vm = this;
    // APEX-977: read-only View mode (locked forms) - hides inline Edit, keeps fields disabled.
    vm.isViewOnly = () => !!vm.application && onboardingActionPolicy.getButtonTitle('2', vm.application) === 'View';
    vm.taxForm;

    vm.onPreview = onPreview;
    vm.onPreviewInPage = onPreviewInPage;
    vm.onDocDownload = onDocDownload;
    vm.onSubmit = onSubmit;
    vm.onShowI9 = onShowI9;
    vm.onClose = onClose;
    vm.onRequestReview = onRequestReview;
    vm.onSave = onSave;
    vm.revealSSNChar = revealSSNChar;
    vm.formatSsn = formatSsn;
    vm.retrieveLocale = retrieveLocale;
    vm.retrieveLocaleTranslations = retrieveLocaleTranslations;
    vm.syncFormToProfile = syncFormToProfile;
    vm.stateWitholdingTypeID = 5;
    vm.reqReview = false;
    vm.isSigned = false;
    vm.prefilled = false;
    vm.editable = true;
    vm.disableEmpFields = true;
    vm.disableEmprFields = false;
    vm.isSaved = false;
    vm.savedData = false;
    vm.showSavedNotification = false;
    vm.previewUrl;
    vm.fillLockedInfo = fillLockedInfo;
    vm.onEditClicked = onEditClicked;
    vm.state = { view: 'W4' };

    vm.$onInit = function () {
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }
        vm.reqReview = false;
        vm.date = moment(new Date(), 'MM/DD/YYYY').toDate();
        vm.stateProvinces = this.provinces;
        vm.userProfile = this.profile;

        vm.retrieveLocale()
            .then(function (locale) {
                return vm.retrieveLocaleTranslations(locale.localeID);
            })
            .then(function (translations) {
                vm.employeeBankInfo.Translations = translations;
            });

        if (vm.savedInputs != null && vm.savedInputs.FullName != null && !vm.ownerView) {
            vm.savedData = true;
            vm.showSavedNotification = true;
            fillEmployee(vm.savedInputs);
        } else if (vm.userInputs != null && vm.userInputs.FullName != null) {
            if (this.application) {
                vm.editable = !(this.application && this.application.HasSW4Form !== null && this.application.ProvinceW4 !== 'Review' && this.application.ProvinceW4 !== 'Submitted' && this.application.ProvinceW4 !== 'Pending');
            }
            fillEmployee(vm.userInputs);
            if (vm.application.ProvinceW4 === "Pending") {
                fillLockedInfo();
            }
        } else {
            prefillFromProfile.call(this);
        }

        if (vm.application.ApplicationStatus === 'Approved' || vm.application.ApplicationStatus === 'Submitted') {
            vm.editable = false;
        }
        if (vm.ownerView && vm.showSignaturePopup) {
            return onPreview();
        }
        vm.editable = resolveEditable();
    }

    function resolveEditable() {
        const appStatus = vm.application.ApplicationStatus;
        const formStatus = vm.application.ProvinceW4;
        if (formStatus === 'ReviewRequired') return true;
        if (appStatus === 'Approved' || appStatus === 'Submitted') return false;
        if (formStatus === 'Submitted' || formStatus === 'Approved') return false;
        if (appStatus === 'Pending') {
            return formStatus === 'Pending' || vm.application.EmployeeStatus !== 'Pending';
        }
        return !vm.application.HasSW4Form || formStatus === 'Pending' || formStatus === 'ReviewRequired';
    }

    // Locked, profile-sourced fields shown read-only.
    function fillLockedFromProfile() {
        vm.fullName = [vm.employeeProfile.FirstName, vm.employeeProfile.MiddleName, vm.employeeProfile.LastName].filter(Boolean).join(' ');
        vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
        const a = vm.profile.HomeAddress;
        vm.address = [a.StreetLine1, a.StreetLine2, a.AptNum].filter(Boolean).join(', ');
        vm.city = a.City;
        vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === a?.StateProvinceID);
        vm.zipCode = a.PostalCode;
    }

    function prefillFromProfile() {
        fillLockedFromProfile();
    }
    function fillLockedInfo() {
        fillLockedFromProfile();
    }

    function onEditClicked() {
        vm.editable = !vm.editable;
        if (vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID === 1 && vm.application.ApplicationStatus === 'Pending') {
            fillLockedFromProfile();
        }
    }

    function toNumOrNull(v) {
        return v != null && v !== '' ? Number(v) : null;
    }

    function fillEmployee(data) {
        fillLockedFromProfile();
        vm.personalExemptions = toNumOrNull(data.PersonalExemptions);
        vm.ageBlindnessExemptions = toNumOrNull(data.AgeBlindnessExemptions);
        vm.totalExemptions = toNumOrNull(data.TotalExemptions);
        vm.addlAmount = toNumOrNull(data.AdditionalStateWithholding);
        vm.notSubjectToWithholding = data.NotSubjectToWithholding === 'On';
        vm.militarySpouseExempt = data.MilitarySpouseExempt === 'On';
        if (data.Signature) {
            vm.signimage = data.Signature; vm.isSigned = true;
        }
        vm.prefilled = true;
        vm.date = moment(data.Date, 'MM/DD/YYYY').toDate();
    }

    // FormRequest is all-string; stringify every value. Numeric exemption/withholding fields
    // autofill "0" when blank (per APEX-867). Step 3/4 checkboxes send PDF on/off literals "On"/"Off".
    function buildFormData(includeSignature) {
        const s = (v) => (v == null ? '' : String(v));
        const num0 = (v) => (v != null && v !== '' ? String(v) : '0'); // autofill 0 when blank
        const formData = {
            RequestTypeId: '2',
            IsI9EmployeeMode: !vm.ownerView,
            FullName: s(vm.fullName),
            EmployeeSocialSecurityNumber: s(vm.employeeSsn),
            EmployeeAddress: s(vm.address),
            EmployeeCity: s(vm.city),
            EmployeeState: s(vm.stateProvince ? vm.stateProvince.Abbr : ''),
            EmployeeZip: s(vm.zipCode),
            PersonalExemptions: num0(vm.personalExemptions),
            AgeBlindnessExemptions: num0(vm.ageBlindnessExemptions),
            TotalExemptions: num0(vm.totalExemptions),
            AdditionalStateWithholding: num0(vm.addlAmount),
            NotSubjectToWithholding: vm.notSubjectToWithholding ? 'On' : 'Off',
            MilitarySpouseExempt: vm.militarySpouseExempt ? 'On' : 'Off',
            Date: moment(vm.date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
            Signature: includeSignature ? vm.signimage : undefined
        };
        return formData;
    }

    $scope.$watch('vm.taxForm.$dirty', function (value) {
        if (value) {
            vm.prefilled = false;
        }
    }, false);

    function onRequestReview() {
        const trans = onboardingDocumentService.saveComment({
            ApplicationId: vm.application.ApplicationId,
            UserName: vm.owner.UserName,
            Text: vm.commentText,
        }).then((res) => {
            if (res) return onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '2');
        }).then(() => {
            vm.close({ $value: 'ok' });
        }).catch((err) => {
            return $q.reject(err);
        });
        utilityService.showLoadingUntilResolved(utilityService.alertOnError(trans, 'Request review failed'));
    }

    function onDocDownload(pages) {
        utilityService.showLoading();
        return onboardingDocumentService.retrieveTemplate(vm.employee.UserName, '1', String(VA_STATE_ID), pages).then(function (result) {
            utilityService.hideLoading();
            return result;
        }).then(function () {
            utilityService.hideLoading();
        });
    }

    // New-Hires-File columns: AA <- Step 1(c) total exemptions, AE <- Step 2 additional withholding (type 5 'S'),
    // AF <- Step 3 or 4 checked. Z/AB/AC/AD not on the VA-4 (left untouched).
    function syncFormToProfile() {
        vm.employeeBankInfo.RegularWithholdingAllowances = vm.totalExemptions;
        vm.employeeBankInfo.EmployeeWithholdingInfos = vm.employeeBankInfo.EmployeeWithholdingInfos.filter(function (x) {
            return x.WithholdingTypeID !== vm.stateWitholdingTypeID;
        });
        if (vm.addlAmount != null && vm.addlAmount !== '') {
            vm.employeeBankInfo.EmployeeWithholdingInfos.push({
                EmployeeId: vm.employee.EmployeeID,
                WithholdingTypeID: vm.stateWitholdingTypeID,
                AdditionalWithholdingAmount: vm.addlAmount
            });
        }
        vm.employeeBankInfo.StateTaxExempt = !!(vm.notSubjectToWithholding || vm.militarySpouseExempt);
    }

    function onPreviewInPage() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields."); return;
        }
        utilityService.showLoading();
        const formData = buildFormData(false);
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, VA_STATE_ID)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...PreviewSignatureModal,
                    resolve: { title: () => "Virginia VA-4", previewUrl: () => vm.previewUrl }
                }).result;
            }).then(function (data) {
                if (!data || !data.dataUrl) {
                    utilityService.hideLoading(); return;
                }
                vm.signimage = data.dataUrl;
                vm.isSigned = data.dataUrl != null;
                return onSubmit();
            }).catch((err) => {
                console.log(err); utilityService.hideLoading();
            });
    }

    function onSave() {
        utilityService.showLoading();
        const formData = buildFormData(false);
        return onboardingDocumentService.save(vm.employee.UserName, formData, VA_STATE_ID).then(function () {
            vm.isSaved = true;
            vm.showSavedNotification = true;
            vm.taxForm.$setPristine();
            return utilityService.hideLoading();
        }).catch(function (err) {
            console.log(err); return utilityService.hideLoading();
        });
    }

    function onApprove() {
        const approvePromise = onboardingDocumentService.approveOnboardingForm(vm.application.ApplicationId, "2");
        const trans = $q.all(approvePromise).then((res) => {
            vm.onShowI9();
        }).catch((err) => {
            return $q.reject(err);
        });
        utilityService.showLoadingUntilResolved(utilityService.alertOnError(trans, "Approve failed"));
    }

    function onSubmit() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields."); return;
        }
        const updatePromises = [];
        vm.isDirtyEdit = vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID !== 2 && vm.application.ApplicationStatus === 'Pending';
        const isPendingResubmit = vm.application.ApplicationStatus === 'Pending' && (vm.application.ProvinceW4 === 'Approved' || vm.application.ProvinceW4 === 'Pending');
        if ((vm.taxForm && vm.taxForm.$dirty) || vm.savedData || vm.isSaved || vm.ownerView || vm.isDirtyEdit || isPendingResubmit || vm.isSigned || vm.application.ProvinceW4 === 'ReviewRequired') {
            if (!vm.isSigned) {
                utilityService.hideLoading(); alert("Preview and Signature are required");
            }
            if (!vm.signimage) {
                utilityService.hideLoading(); alert("Signature is required"); return;
            }
            const formData = buildFormData(true);
            if (!vm.ownerView) {
                syncFormToProfile();
                updatePromises.push(() => employeeService.updateEmployeeOnboardingBankInfo(vm.employee.EmployeeID, vm.employeeBankInfo));
            }
            updatePromises.push(() => onboardingDocumentService.submit(vm.employee.UserName, formData, VA_STATE_ID));
        }
        if (!Array.isArray(updatePromises) || updatePromises.length === 0) {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }
        }
        const trans = updatePromises.reduce((chain, promise) => {
            return chain.then(() => (typeof promise === 'function' ? promise() : promise));
        }, $q.resolve()).then((res) => {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }
        }).catch((err) => {
            return $q.reject(err);
        });
        utilityService.showLoadingUntilResolved(utilityService.alertOnError(trans, "Save failed"));
    }

    function onPreview() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields."); return;
        }
        utilityService.showLoading();
        const formData = buildFormData(true);
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, VA_STATE_ID)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...OwnerPreviewSignatureModal,
                    resolve: {
                        title: () => "Virginia VA-4",
                        previewUrl: () => vm.previewUrl,
                        allowApprove: () => canApproveForm(vm.application, '2'),
                        allowSign: () => false,
                        showSignaturePopup: () => vm.showSignaturePopup
                    }
                }).result;
            }).then(function (data) {
                if (data === 'terminate' && vm.showSignaturePopup) {
                    return vm.close({ $value: 'ok' });
                }
                if (data && data.success) {
                    vm.employerSignimage = data.dataUrl; vm.isSigned = true; return onSubmit();
                }
            }).catch((err) => {
                console.log(err); utilityService.hideLoading();
            });
    }

    $scope.$on('modal.closing', function (event, reason, closed) {
        if (reason !== 'ok') {
            return onClose(event);
        }
    });

    function onClose(event) {
        if (vm.taxForm && vm.taxForm.$dirty) {
            event.preventDefault();
            $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => "Your form is not completed yet. Do you want to leave?",
                    state: () => "application-status"
                },
                controller: function ConfirmModalController($uibModalInstance) {
                    'ngInject'
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then(function (data) {
                if (data === 'ok') {
                    vm.close({ $value: 'ok' });
                }
            }, function (dismiss) {
                console.log(dismiss);
            });
        }
    }

    function onShowI9() {
        vm.close({ $value: 'ok' });
    }

    function retrieveLocaleTranslations(localeID) {
        return localeService.retrieveLocaleTranslations(localeID).then(function (translations) {
            return translations;
        });
    }

    function retrieveLocale() {
        return localeService.retrieveLocales()
            .then(function (locales) {
                return locales.filter(function (locale) {
                    return locale.countryID === vm.employeeBankInfo.CountryID;
                })[0] || localeService.retrieveCurrentLocale();
            })
            .then(function (locale) {
                if (locale) {
                    return locale;
                }
            });
    }

    function formatSsn(ssn) {
        if (!ssn) return "";
        var digits = ("" + ssn).replace(/[^0-9]/g, "");
        if (digits.length !== 9) return ssn;
        var mask = vm.employeeBankInfo
            && vm.employeeBankInfo.Translations
            && vm.employeeBankInfo.Translations.SSNMask;
        if (mask === "000-000-000") {
            return digits.slice(0, 3) + "-" + digits.slice(3, 6) + "-" + digits.slice(6, 9);
        }
        return digits.slice(0, 3) + "-" + digits.slice(3, 5) + "-" + digits.slice(5, 9);
    }

    function revealSSNChar(ssn, char, i) {
        return i > 4;
    }
}

export const VAW4Modal = {
    component: "apexVAW4Modal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}
